import { render, staticRenderFns } from "./StandardContractsList.vue?vue&type=template&id=3ee1f7c1&scoped=true&"
import script from "./StandardContractsList.vue?vue&type=script&lang=js&"
export * from "./StandardContractsList.vue?vue&type=script&lang=js&"
import style0 from "./StandardContractsList.vue?vue&type=style&index=0&id=3ee1f7c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee1f7c1",
  null
  
)

export default component.exports